import React, { useEffect, useState } from "react";
import { FilterOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import { getRotoPaginationListNew } from "services/redux/Roto/action";
import RotoTemplateViewTable from "./RotoTemplateViewTable";
import RotoTemplateAddUpdateForm from "./RotoTemplateAddUpdateForm";
import RotoFilter from "./RotoFilter";

const RotoMain = ({ openForm, setOpenForm }) => {
  const { getRotoListingLoading } = useSelector((state) => state.rotoReducer);
  const [filterModal, setFilterModal] = useState({
    visible: false,
    loading: false,
  });
  const [filterData, setFilterData] = useState();
  const [updateData, setUpdateData] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!getRotoListingLoading) {
      setFilterModal({
        visible: false,
        loading: false,
      });
    }
  }, [getRotoListingLoading]);

  const advancedSearch = (values) => {
    setFilterModal({
      ...filterModal,
      loading: true,
    });
    const newValues = {
      // SearchKeyword: values.SearchKeyword ?? "",
      // ScopeOfWorks: values.SearchKeyword ?? "",
      ...values,
      // searchDateFrom: startDate ?? "",
      // searchDateTo: endDate ?? "",
      tenderTypes: values.tenderTypes && [values.tenderTypes],
      sectorTypes: values.sectorTypes && [values.sectorTypes],
      skipCount: 0,
      maxResultCount: 10,
    };

    setFilterData(newValues);

    // dispatch(getSOWDetails(newValues));
    dispatch(getRotoPaginationListNew(newValues));
  };

  return (
    <>
      <div>
        <div className="organizer__list todo__list">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 className="header__all">Roto</h3>
            <span
              className="side__search__wrapper side-contact-search-filter"
              style={{
                cursor: "pointer",
                height: "25px",
                marginTop: "5 px",
              }}
              onClick={() => {
                setFilterModal({
                  visible: true,
                  loading: false,
                });
              }}
            >
              <FilterOutlined />
            </span>
          </div>
        </div>
        <RotoTemplateViewTable
          filterData={filterData}
          setOpenForm={setOpenForm}
          setUpdateData={setUpdateData}
        />

        <RotoTemplateAddUpdateForm
          openForm={openForm}
          setOpenForm={setOpenForm}
          updateData={updateData}
          setUpdateData={setUpdateData}
        />
        <RotoFilter
          filterModal={filterModal}
          setFilterModal={setFilterModal}
          advancedSearch={advancedSearch}
        />
      </div>
    </>
  );
};

export default RotoMain;
